export const refundStatusLabel: Record<API.Staff.OrderRefundStatus, string> = {
  CREATED: "退款单已创建",
  PROCESSING: "微信退款处理中",
  SUCCESS: "微信退款成功",
  CLOSED: "微信退款已关闭",
  ABNORMAL: "微信退款异常",
}

export const refundStatusColor: Record<API.Staff.OrderRefundStatus, string> = {
  CREATED: "default",
  PROCESSING: "gold",
  SUCCESS: "green",
  CLOSED: "default",
  ABNORMAL: "red",
}

export const applyStatusLabel: Record<
  API.Staff.OrderRefundApplyStatus,
  string
> = {
  PENDING: "待核销",
  APPLIED: "已核销",
}

export const applyStatusColor: Record<
  API.Staff.OrderRefundApplyStatus,
  string
> = {
  PENDING: "orange",
  APPLIED: "green",
}
